import styled from "styled-components";

export const BoxModal = styled.div`
	background-color: #fff;
	border-radius: 8px;
	padding: 1rem;
	width: 400px;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const Title = styled.div`
	font-weight: bold;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;

export const AreaButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 1rem;
`;

export const FileUploaderWrapepr = styled.div`
	> #id-general-containerPreview {
		justify-content: center;
	}
`;
